import { VIEW_TYPE } from '../../../../enums/ViewType';
import VisitorTabTable from "./SubComponents/VisitorTabTable";
import VisitorTabApp from "./Functionality/VisitorTabApp";
import VisitorTabCard from "./SubComponents/VisitorTabCard";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : FullStack
 * @Email : kpozos@ibl.mx
 *
 */
const VisitorTab = (props) => {
    const {selectedList, setSelectedList, searchElement, setSearchElement, setCriteria, setBodyForExport, finalArray, setFinalArray,
        search, setSearch, deleteModal, setDeleteModal, modified, setModified, setShowVisitorModal,
        viewOrigin, setShowRequestAccessModal, handleSubViewChange, subView, showSuccessMsgRef } = props;
    const { goUpdate, getChildrenNotInformation, view, setView } = VisitorTabApp({setSearchElement, viewOrigin, setShowVisitorModal});

    return (
        <>
            {view === VIEW_TYPE.LIST.name ? (
                <VisitorTabTable
                    selectedList={selectedList}
                    setSelectedList={setSelectedList}
                    view={view}
                    setView={setView}
                    setCriteria={setCriteria}
                    setBodyForExport={setBodyForExport}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    finalArray={finalArray}
                    setFinalArray={setFinalArray}
                    search={search}
                    setSearch={setSearch}
                    deleteModal={deleteModal}
                    setDeleteModal={setDeleteModal}
                    goUpdate={goUpdate}
                    modified={modified}
                    setModified={setModified}
                    setShowVisitorModal={setShowVisitorModal}
                    viewOrigin={viewOrigin}
                    setShowRequestAccessModal={setShowRequestAccessModal}
                    getChildrenNotInformation={getChildrenNotInformation}
                    handleSubViewChange={handleSubViewChange}
                    subView={subView}
                    showSuccessMsgRef={showSuccessMsgRef}
                />
            ):
                <VisitorTabCard
                    selectedList={selectedList}
                    setSelectedList={setSelectedList}
                    view={view}
                    setView={setView}
                    setCriteria={setCriteria}
                    setBodyForExport={setBodyForExport}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    finalArray={finalArray}
                    setFinalArray={setFinalArray}
                    search={search}
                    setSearch={setSearch}
                    deleteModal={deleteModal}
                    setDeleteModal={setDeleteModal}
                    goUpdate={goUpdate}
                    modified={modified}
                    setModified={setModified}
                    setShowVisitorModal={setShowVisitorModal}
                    viewOrigin={viewOrigin}
                    setShowRequestAccessModal={setShowRequestAccessModal}
                    getChildrenNotInformation={getChildrenNotInformation}
                    handleSubViewChange={handleSubViewChange}
                    subView={subView}
                    showSuccessMsgRef={showSuccessMsgRef}
                />
            }
        </>
    );
};

export default VisitorTab;
